<script>
import IconSearch from "../../../assets/icons/ic-search.svg";
import IconFiltre from "../../../assets/icons/ic-filtre.svg";
import radio from "../../helper/form/radio.vue";
import icKa from "../../../assets/icons/ic-ka.svg";
import Tel from "../../../assets/icons/ic-telephone.svg";
import { getRequestExpert } from "@/component/cdevs/allFunctions";
import requestLists from "./requestLists.vue";
import detailsRequest from "./detailsRequest.vue";
import multiselect from "@/component/helper/form/multiselect"

export default {
  name: "AllCharteredAccountant",
  components: { requestLists, radio, detailsRequest, multiselect },
  data() {
    return {
      icons: { IconSearch, IconFiltre, icKa, Tel },
      all_request: [],
      charge: false,
      empty: false,
      limit: 1000,
      page: 1,
      search: "",
      searchCompany: "", // Recherche par nom d'entreprise
      searchCompanyOther: "", // Recherche par autres champs de l'entreprise
      timer: null,
      timerCompany: null,
      timerCompanyOther: null,
      isDetail: false,
      oneDetail: null,
      allState: ['TOUS', 'EN ATTENTE', 'TRAITÉ', 'REJETÉ'],
      filter: "TOUS"
    };
  },

  created() {
    this.getAllRequestExpert(this.limit, this.page, this.search, this.filter, this.searchCompany, this.searchCompanyOther);
  },

  methods: {
    // ✅ Fonction pour afficher les détails de l'entreprise
    showCompanyDetails(item) {
      console.log("Item reçu:", item);
      
      // Vérification de la structure des données
      let companyData = null;
      
      if (item.company) {
        // Structure: { company: {...}, request: {...} }
        companyData = item.company;
      } else if (item.commerce) {
        // Structure: { commerce: {...} }
        companyData = item.commerce;
      } else if (item.id) {
        // Structure directe de l'entreprise
        companyData = item;
      }
      
      if (!companyData || !companyData.id) {
        console.error("Structure de données invalide:", item);
        this.$toast.error("Impossible de charger les détails de l'entreprise");
        return;
      }
      
      console.log("Company data à sauvegarder:", companyData);
      
      // Sauvegarde dans le store (synchrone avec Vuex)
      this.$store.dispatch("saveCompany", companyData);
      
      // Vérification immédiate du store
      setTimeout(() => {
        const storedCompany = this.$store.getters.trackCompany;
        console.log("Données stockées dans le store:", storedCompany);
        
        if (storedCompany && storedCompany.id) {
          console.log("Navigation vers commerceDetail");
          this.$router.push("commerceDetail");
        } else {
          console.error("Échec de la sauvegarde dans le store");
          this.$toast.error("Erreur lors de la sauvegarde des données");
        }
      }, 100);
    },

    cleanObject(obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([_, value]) => value !== null && value !== undefined && value !== ""
        )
      );
    },

    sendType (a) {
      if(a === 'EN ATTENTE'){
        this.filter = 'WAITING'
      } else if(a === 'TRAITÉ'){
        this.filter = 'TREATED'
      }else if(a === 'REJETÉ'){
        this.filter = 'REJECTED'
      }else {
        this.filter = 'TOUS'
      }
      this.getAllRequestExpert(this.limit, this.page, this.search, this.filter, this.searchCompany, this.searchCompanyOther);
    },

    /* Function to get all accountant request */
    async getAllRequestExpert(limit, page, search, state, searchCompany, searchCompanyOther) {
      this.charge = true;
      const data = {
        apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
        limit: limit,
        page: page,
        search: search,
        state: state
      };

      if (this.filter === 'TOUS') {
        delete data.state;
      }
      if (!this.search) {
        delete data.search;
      }
      
      // Ajouter les paramètres de recherche pour l'entreprise
      if (searchCompany) {
        data.searchCompany = searchCompany;
      }
      if (searchCompanyOther) {
        data.searchCompanyOther = searchCompanyOther;
      }
      
      await getRequestExpert(data)
        .then((response) => {
          console.log("Réponse getAllRequestExpert:", response);
          let results = response.data || response;
          
          // Si l'API ne filtre pas côté serveur, filtrer côté client
          if (Array.isArray(results)) {
            if (searchCompany) {
              results = results.filter(item => {
                const companyName = item.company?.fullName || item.company?.name || '';
                return companyName.toLowerCase().includes(searchCompany.toLowerCase());
              });
            }
            
            if (searchCompanyOther) {
              results = results.filter(item => {
                const searchLower = searchCompanyOther.toLowerCase();
                // Rechercher dans les données du comptable (clientChoice)
                const clientChoice = item.request?.clientChoice || {};
                const accountantFirstName = clientChoice.firstName || '';
                const accountantLastName = clientChoice.lastName || '';
                const accountantFullName = `${accountantFirstName} ${accountantLastName}`.trim();
                const accountantEmail = clientChoice.email || '';
                const accountantPhone = clientChoice.phone || clientChoice.phoneNumber || '';
                
                return (
                  accountantFullName.toLowerCase().includes(searchLower) ||
                  accountantFirstName.toLowerCase().includes(searchLower) ||
                  accountantLastName.toLowerCase().includes(searchLower) ||
                  accountantEmail.toLowerCase().includes(searchLower) ||
                  accountantPhone.toLowerCase().includes(searchLower)
                );
              });
            }
          }
          
          this.all_request = results;
          this.charge = false;
        })
        .catch((error) => {
          console.error("Erreur getAllRequestExpert:", error);
          this.charge = false;
          this.$toast.error("Une erreur est survenue");
        });
    },

    // ✅ Fonction pour ouvrir les détails de la demande (pas de l'entreprise)
    openDetail(val){
      this.isDetail = true
      this.oneDetail = val
    },

    closeDetail(value) {
      if (value) {
        this.getAllRequestExpert(this.limit, this.page, this.search, this.filter, this.searchCompany, this.searchCompanyOther);
      }
      this.isDetail = false
    }
  },

  watch: {
    search(newValue) {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        this.getAllRequestExpert(this.limit, this.page, newValue, this.filter, this.searchCompany, this.searchCompanyOther);
      }, 300);
    },
    searchCompany(newValue) {
      if (this.timerCompany) {
        clearTimeout(this.timerCompany);
      }

      this.timerCompany = setTimeout(() => {
        this.getAllRequestExpert(this.limit, this.page, this.search, this.filter, newValue, this.searchCompanyOther);
      }, 300);
    },
    searchCompanyOther(newValue) {
      if (this.timerCompanyOther) {
        clearTimeout(this.timerCompanyOther);
      }

      this.timerCompanyOther = setTimeout(() => {
        this.getAllRequestExpert(this.limit, this.page, this.search, this.filter, this.searchCompany, newValue);
      }, 300);
    },
  },
};
</script>

<template>
  <div class="">
    <div class="flex justify-start responsive-container">
      <div class="flex items-center justify-start gap-5 w-1/2">
        <div
          class="flex items-center justify-start border border-gray py-2 rounded-100 w-1/2"
        >
          <icon
            :data="icons.IconSearch"
            height="20"
            width="20"
            class="w-5 h-5 mx-4"
            original
          />
          <input
            v-model="searchCompany"
            type="text"
            class="text-c16 responsive-input rounded-100 w-full"
            placeholder="Rechercher par nom d'entreprise"
          >
        </div>
        <div
          class="flex items-center justify-start border border-gray py-2 rounded-100 w-1/2"
        >
          <icon
            :data="icons.IconSearch"
            height="20"
            width="20"
            class="w-5 h-5 mx-4"
            original
          />
          <input
            v-model="searchCompanyOther"
            type="text"
            class="text-c16 responsive-input rounded-100 w-full"
            placeholder="Rechercher par comptable"
          >
        </div>
        <div>
          <multiselect
            :value-t="allState[0]"
            :option="allState"
            @info="sendType"
            height="42px"
            radius="8px"
            size="16px"
            background="#FFF"
            border="1px solid #EDEDEE"
          />
        </div>
      </div>
    </div>

    <div class="responsive-container">
      <div
        class="backg w-full flex items-center TextColor h-14 px-5 rounded-t-10 mt-5"
      >
        <div class="flex items-center gap-5 w-1/2">
          <radio />
          <div>Entreprise</div>
        </div>
        <div class="w-1/2 flex justify-start">Comptable demandé</div>
        <!-- <div class="w-1/2 flex justify-start">Comptable affecté</div> -->
        <div class="w-1/3 flex justify-start">Date de demande</div>
        <div class="w-1/3 flex justify-start">Date du besoin</div>
        <div class="w-1/3 flex justify-start">Statut</div>
      </div>

      <div v-if="charge" class="flex justify-center mt-16">
        <easy-spinner type="dots" size="70" />
      </div>

      <div class="text-center my-10" v-if="all_request.length === 0 && !charge">
        Aucune demande de service pour le moment
      </div>

      <div class="w-full">
        <requestLists
          v-for="(item, i) in all_request"
          :key="i"
          :one-request="item"
          @openDetail="openDetail(item)"
          @showCompanyDetails="showCompanyDetails(item)"
        />
      </div>
    </div>
    
    <!-- Details Request service -->
    <div v-if="isDetail">
      <detailsRequest @closeDetail="closeDetail" :one-detail="oneDetail" />
    </div>
  </div>
</template>

<style>
.backg {
  background-color: #eff5f9;
}
.TextColor {
  color: #6b6b75;
  font-size: 16px;
  line-height: 18px;
  font-weight: 400;
}
.BorderColor {
  border-bottom: 1px solid #e7eef8;
}
.listeStyle {
  font-weight: 400;
  font-size: 18px;
}
.Email {
  color: #6aa3f2;
}
</style>
